import {
 Link
} from 'react-router-dom'
const TopSingersHome = ()=>{

  const topMusics =[
    {
      id: 1,
      name: "Therefore I am",
      cover: "https://i1.sndcdn.com/artworks-3wyJXJt4mvuideyh-txiGkA-t500x500.jpg",
      artists:[
        {
          id: 1,
          name: "Billie Eilish",
          photo: "http://www.gstatic.com/tv/thumb/persons/1039407/1039407_v9_bb.jpg",
          category: "Pop"
        }
      ]
    },
    {
      id: 2,
      name: "GOOBA",
      cover: "https://upload.wikimedia.org/wikipedia/en/6/63/6ix9ine_-_TattleTales.png",
      artists:[
        {
          id: 1,
          name: "6ix9ine",
          photo: "https://yt3.ggpht.com/ytc/AAUvwni_Gpopv7lk5LnQ4ZMWOWwtGwU7o51vGuBtUmIN-A=s176-c-k-c0x00ffffff-no-rj",
          category: "Pop"
        }
      ]
    },
    {
      id: 3,
      name: "ANYONE",
      cover: "https://upload.wikimedia.org/wikipedia/en/0/0d/Justin_Bieber_-_Anyone.png",
      artists:[
        {
          id: 1,
          name: "Justin Bieber",
          photo: "https://yt3.ggpht.com/ytc/AAUvwnglHQ743JZySyyAHbRXNq_RMCpU_h5kAytiluSitA=s176-c-k-c0x00ffffff-no-rj",
          category: "Pop"
        }
      ]
    },
    {
      id: 4,
      name: "Monster",
      cover: "https://www.thelivemirror.com/wp-content/uploads/2020/11/Justin-Bieber-and-Shawn-Mendes-Monster.jpg",
      artists:[
        {
          id: 1,
          name: "Justin Bieber",
          photo: "https://yt3.ggpht.com/ytc/AAUvwni_Gpopv7lk5LnQ4ZMWOWwtGwU7o51vGuBtUmIN-A=s176-c-k-c0x00ffffff-no-rj",
          category: "Pop"
        },
        {
          id: 2,
          name: "Shawn Mendes",
          photo: "https://yt3.ggpht.com/ytc/AAUvwni_Gpopv7lk5LnQ4ZMWOWwtGwU7o51vGuBtUmIN-A=s176-c-k-c0x00ffffff-no-rj",
          category: "Pop"
        }
      ]
    }
  ]

    return(
<div className="app-bg-dark app-text-white">
 <div className="container py-4">
<ul className="nav nav-pills" id="pills" role="tablist">
  <li className="nav-item">
    <a className="nav-link active" id="must-listen" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Must Listen</a>
  </li>
  <li className="nav-item">
    <a className="nav-link" id="daily-1oohits" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Daily Top 100</a>
  </li>
  <li className="nav-item">
    <a className="nav-link" id="new-music" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">New Music</a>
  </li>
</ul>
<div className="tab-content py-3" id="topSongArtists">
  <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="must-listen">
      <div className="row">
         {
           topMusics.map((song)=>(
            <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12" key={song.id}>
              <div className="song-container">
              <div className="image-cover">
              <img src={song.cover} alt={`${song.name}`}/>
              </div>
              <div className="song-description">
              <h2>{song.name}</h2>
              {
                song.artists.map((artist)=>(
                  <Link to={`/artist/${artist.name.replace(/ +/g, "").toLocaleLowerCase()}`} key={artist.id}>{artist.name}&emsp;</Link>
                  // art=${artist.name.replace(/ +/g, "").toLocaleLowerCase()}
                ))
              }
              </div>
              <div className="play-icon centered"><i className="fa fa-play"></i></div>
              </div>
            </div>
           ))
         }
      </div>
    </div>
    <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="daily-1oohits">...</div>
  <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="new-music">...</div>
</div>
</div>
</div>
    )
}

export default TopSingersHome;